import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import api from "../../api";

import styles from "./TaskReceivedList.module.css";
import TaskQnA from "./TaskQnA";  

export default function TaskReceivedList() {
  const navigate = useNavigate();
  const [tasks, setTasks]       = useState([]);
  const [filter, setFilter]     = useState("all");
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);
  const [me, setMe] = useState(null);
  const [unreadTaskIds, setUnreadTaskIds] = useState(new Set());
  const [searchQuery, setSearchQuery] = useState("");


  const [actualModal, setActualModal] = useState(null);
  const [actualDiff, setActualDiff]   = useState(5);
  const [actualHours, setActualHours] = useState(0);
  const [actualMins, setActualMins]   = useState(0);

  const [completeChoice, setCompleteChoice] = useState(null);






  useEffect(() => {
    api.get("/tasks/notifications/").then(res => {
      const ids = new Set(
        res.data
          .filter(n => !n.is_read && ["task_assigned","task_comment_to_assignee","task_answer"].includes(n.ntype))
          .map(n => n.task)
      );
      setUnreadTaskIds(ids);
    }).catch(() => {});
  }, []);

  const fetchTasks = async () => {
    try {
      const res = await api.get("/tasks/received/");
      setTasks(res.data);


    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchTasks(); }, []);

  
  // 변경 후
  useEffect(() => {                     // ← 추가
    api.get("/users/me/").then(res => setMe(res.data.id));
  }, []);

  const location = useLocation();
  useEffect(() => {
    if (!location.state?.openTaskId || tasks.length === 0) return;
    const target = tasks.find(t => t.id === location.state.openTaskId);
    if (target) setSelected(target);
  }, [tasks, location.state]);
  const handleComplete = async (id) => {
    if (!window.confirm("완료 처리하시겠습니까?")) return;
    try {
      await api.patch(`/tasks/${id}/complete/`, {});
      alert("완료 처리되었습니다. 지시자에게 알람이 전송됩니다.");
      fetchTasks();
    } catch (e) {
      alert("완료 처리 중 오류가 발생했습니다.");
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    const label = newStatus === "inprogress" ? "진행중" : "완료";
    if (!window.confirm(`"${label}"으로 변경하시겠습니까?`)) return;
    try {
      await api.patch(`/tasks/${id}/status/`, { status: newStatus });
      fetchTasks();
    } catch (e) {
      alert("상태 변경 중 오류가 발생했습니다.");
    }
  };

  const handleCompleteFlow = (task) => {
    setCompleteChoice(task);
  };
  
  // 수정 → 실제 난이도·소요시간 입력 모달 띄우기
  const handleChooseEdit = () => {
    const task = completeChoice;
    setActualDiff(task.difficulty ?? 5);
    setActualHours(task.est_minutes != null ? Math.floor(task.est_minutes / 60) : 0);
    setActualMins(task.est_minutes != null ? task.est_minutes % 60 : 0);
    setCompleteChoice(null);
    setActualModal(task);
  };
  
  // 미수정 → 지시대로 바로 완료
  const handleChooseSkip = async () => {
    const task = completeChoice;
    setCompleteChoice(null);
    try {
      await api.patch(`/tasks/${task.id}/status/`, { status: "done" });
      setSelected(null);
      fetchTasks();
    } catch (e) {
      alert("상태 변경 중 오류가 발생했습니다.");
    }
  };



  const handleActualSave = async () => {
    try {
      await api.patch(`/tasks/${actualModal.id}/actual/`, {
        actual_difficulty: Number(actualDiff),
        actual_minutes: Number(actualHours) * 60 + Number(actualMins),
      });
      await api.patch(`/tasks/${actualModal.id}/status/`, { status: "done" });
      setActualModal(null);
      setSelected(null);
      fetchTasks();
    } catch (e) {
      alert("저장 중 오류가 발생했습니다.");
    }
  };




  const q = searchQuery.trim().toLowerCase();
  const filtered = (
    filter === "all" ? tasks
    : filter === "chat" ? tasks.filter((t) => t.comment_count > 0)
    : tasks.filter((t) => t.status === filter)
  ).filter((t) =>
    !q ||
    t.title.toLowerCase().includes(q) ||
    t.content?.toLowerCase().includes(q) ||
    t.assigner_name?.toLowerCase().includes(q)
  );

  const total    = tasks.length;
  const done     = tasks.filter((t) => t.status === "done").length;
  const pending  = tasks.filter((t) => t.status === "pending").length;
  const inprog   = tasks.filter((t) => t.status === "inprogress").length;
  const hasChat  = tasks.filter((t) => t.comment_count > 0 && t.status !== "done").length;
  const isOverdue = (due) => {
    if (!due) return false;
    return new Date(due) < new Date(new Date().toDateString());
  };

  const starDisplay = (n) => "★".repeat(n) + "☆".repeat(3 - n);

  return (
    <div className={styles.wrap}>
      <div className={styles.panel}>

        <div className={styles.top}>
          <span className={styles.title}>받은 업무 목록</span>
        </div>

        {/* 요약 카드 */}
        <div className={styles.summary}>
          <div className={styles.scard}>
            <div className={styles.scardLabel}>전체</div>
            <div className={styles.scardNum}>{total}</div>
          </div>
          <div className={styles.scard}>
            <div className={styles.scardLabel}>대기</div>
            <div className={`${styles.scardNum} ${styles.amber}`}>{pending}</div>
          </div>
          <div className={styles.scard}>
            <div className={styles.scardLabel}>질문/답변 중</div>
            <div className={`${styles.scardNum} ${styles.blue}`}>{hasChat}</div>
          </div>

          <div className={styles.scard}>
            <div className={styles.scardLabel}>진행중</div>
            <div className={`${styles.scardNum} ${styles.amber}`}>{inprog}</div>
          </div>

          <div className={styles.scard}>
            <div className={styles.scardLabel}>완료</div>
            <div className={`${styles.scardNum} ${styles.green}`}>{done}</div>
          </div>
        </div>

        {/* 필터 */}
        <div className={styles.filterRow}>
          {[
            { key: "all",        label: "전체" },
            { key: "pending",    label: "대기" },
            { key: "chat",       label: "질문/답변" },

            { key: "inprogress", label: "진행중" },
            { key: "done",       label: "완료" },
          ].map((f) => (
            <button
              key={f.key}
              type="button"
              className={`${styles.filterBtn} ${filter === f.key ? styles.filterOn : ""}`}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
          <input
            type="text"
            className={styles.searchInput}
            placeholder="제목·내용·지시자 검색"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>  {/* filterRow 끝 */}

        {/* 모바일 카드 리스트 */}
        <div className={styles.mobileList}>
          {loading ? (
            <div className={styles.empty}>불러오는 중...</div>
          ) : filtered.length === 0 ? (
            <div className={styles.empty}>해당하는 업무가 없습니다.</div>
          ) : (
            filtered.map((t) => (
              <div key={t.id} className={styles.taskCard}>
                <div
                  className={styles.taskCardTitle}
                  onClick={() => setSelected(t)}
                >
                  {t.title}
                </div>
                <div className={styles.taskCardRow}>
                  <span className={styles.taskCardLabel}>지시자</span>
                  <span className={styles.taskCardValue}>{t.assigner_name}</span>
                </div>
                <div className={styles.taskCardRow}>
                  <span className={styles.taskCardLabel}>중요도</span>
                  <span className={`${styles.taskCardValue} ${styles.stars}`}>
                    {"★".repeat(t.priority)}{"☆".repeat(3 - t.priority)}
                  </span>
                </div>
                <div className={styles.taskCardRow}>
                  <span className={styles.taskCardLabel}>기한</span>
                  <span className={`${styles.taskCardValue} ${isOverdue(t.due_date) && t.status !== "done" ? styles.overdue : ""}`}>
                    {t.due_date?.slice(0, 16).replace("T", " ")}
                  </span>
                </div>
                <div className={styles.taskCardRow}>
                  <span className={styles.taskCardLabel}>지시일</span>
                  <span className={styles.taskCardValue}>{t.created_at?.slice(0, 10)}</span>
                </div>


                <div className={styles.taskCardRow}>
                  <span className={styles.taskCardLabel}>상태</span>
                  <span className={styles.taskCardValue}>
                    {unreadTaskIds.has(t.id) && <span style={{marginRight:4}}>🔔</span>}
                    <span className={`${styles.badge} ${styles["b_" + t.status]}`}>
                      {t.status_display}
                    </span>


                    {t.comment_count > 0 && (
                      <span className={styles.bChat}>💬</span>
                    )}

                  </span>
                </div>


                <div className={styles.taskCardBtns}>
                  <button
                    type="button"
                    className={styles.btnDetail}
                    onClick={() => setSelected(t)}
                  >
                    상세보기
                  </button>
                  {t.status === "pending" && (
                    <button
                      type="button"
                      className={styles.btnInprogress}
                      onClick={() => handleStatusChange(t.id, "inprogress")}
                    >
                      진행중
                    </button>
                  )}
                  {t.status !== "done" && (
                    <button
                      type="button"
                      className={styles.btnComplete}
                      onClick={() => handleCompleteFlow(t)}


                    >
                      완료
                    </button>
                  )}
                  {t.status === "done" && (
                    <span className={styles.doneText}>완료됨</span>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* 테이블 (PC용 — 모바일에서 숨김) */}
        <div className={styles.tableWrap}>

          {loading ? (
            <div className={styles.empty}>불러오는 중...</div>
          ) : filtered.length === 0 ? (
            <div className={styles.empty}>해당하는 업무가 없습니다.</div>
          ) : (
            <table className={styles.table}>

              <thead>
                <tr>
                  <th style={{width:"32%"}}>업무 제목</th>
                  <th style={{width:"8%"}}>지시자</th>
                  <th style={{width:"6%"}}>긴급도</th>
                  <th style={{width:"6%"}}>난이도</th>
                  <th style={{width:"7%"}}>소요시간</th>
                  <th style={{width:"11%"}}>기한</th>
                  <th style={{width:"7%"}}>지시일</th>
                  <th style={{width:"6%"}}>상태</th>
                  <th style={{width:"17%"}}></th>
                </tr>


              </thead>


              <tbody>
                {filtered.map((t) => (
                  <tr key={t.id}>

                    <td
                      className={styles.titleCell}
                      onClick={() => setSelected(t)}
                    >
                      {t.title}
                    </td>

                    <td>{t.assigner_name}</td>
                    <td className={styles.stars}>{starDisplay(t.priority)}</td>
                    <td>{t.difficulty != null ? `${t.difficulty}/10` : "-"}</td>
                    <td>{t.est_minutes != null
                      ? t.est_minutes < 60
                        ? `${t.est_minutes}분`
                        : t.est_minutes % 60 === 0
                          ? `${Math.floor(t.est_minutes / 60)}시간`
                          : `${Math.floor(t.est_minutes / 60)}시간 ${t.est_minutes % 60}분`           
                      : "-"}</td>
                    <td className={isOverdue(t.due_date) && t.status !== "done" ? styles.overdue : ""}>
                      {t.due_date?.slice(0, 16).replace("T", " ")}

                    </td>
                    <td>{t.created_at?.slice(0, 10)}</td>

                    <td>
                      {unreadTaskIds.has(t.id) && <span style={{marginRight:4}}>🔔</span>}
                      <span className={`${styles.badge} ${styles["b_" + t.status]}`}>  
                        {t.status_display}
                      </span>

                      {t.comment_count > 0 && (
                        <span className={styles.bChat}>💬</span>
                      )}


                    </td>

                    <td style={{display:"flex", gap:4, alignItems:"center", justifyContent:"center", flexWrap:"nowrap"}}>
                      <button type="button" className={styles.btnDetail} onClick={() => setSelected(t)}>상세보기</button>
                      {t.status === "pending" && (
                        <button type="button" className={styles.btnInprogress} onClick={() => handleStatusChange(t.id, "inprogress")}>진행중</button>
                      )}
                      {t.status !== "done" && (
                        <button type="button" className={styles.btnComplete} onClick={() => handleCompleteFlow(t)}>완료</button>
                      )}
                      {t.status === "done" && (
                        <span className={styles.doneText}>완료됨</span>
                      )}
                      <button type="button" className={styles.btnAsk} onClick={() => setSelected(t)}>질문/답변</button>

                    </td>


                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {selected && (
          <div style={{
            position:"fixed", inset:0, background:"rgba(0,0,0,0.45)",
            display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000
          }} onClick={() => setSelected(null)}>
            <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>

              {/* 왼쪽: 상세 내용 */}
              <div className={styles.modalLeft}>
                <span style={{fontSize:15, fontWeight:700, display:"block", marginBottom:12}}>{selected.title}</span>

                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 12px", fontSize:13}}>
                  {[
                    ["지시자", selected.assigner_name],
                    ["수신자", selected.assignee_name],
                    ["긴급도", "★".repeat(selected.priority) + "☆".repeat(3 - selected.priority)],
                    ["업무 종류", selected.work_category_name || "-"],
                    ["난이도", selected.difficulty != null ? `${selected.difficulty} / 10` : "-"],


                    ["예상 소요", selected.est_minutes != null
                      ? selected.est_minutes < 60
                        ? `${selected.est_minutes}분`
                        : selected.est_minutes % 60 === 0
                          ? `${Math.floor(selected.est_minutes / 60)}시간`
                          : `${Math.floor(selected.est_minutes / 60)}시간 ${selected.est_minutes % 60}분`
                      : "-"],
                    ["실제 소요", selected.actual_minutes != null
                      ? selected.actual_minutes < 60
                        ? `${selected.actual_minutes}분`
                        : selected.actual_minutes % 60 === 0
                          ? `${Math.floor(selected.actual_minutes / 60)}시간`
                          : `${Math.floor(selected.actual_minutes / 60)}시간 ${selected.actual_minutes % 60}분`
                      : "-"],



                    ["상태",   selected.status_display],
                    ["지시일", selected.created_at?.slice(0,10)],
                  ].map(([label, value]) => (


                    

                    <div key={label} style={{display:"flex", flexDirection:"column", padding:"8px 0", borderBottom:"1px solid #f0f0f0"}}>
                      <span style={{fontSize:11, color:"#888", marginBottom:3}}>{label}</span>
                      <span style={{fontWeight:500}}>{value}</span>
                    </div>
                  ))}
                </div>

                <div style={{marginTop:16}}>
                  <div style={{fontSize:12, color:"#2b7a2b", fontWeight:700, marginBottom:6}}>업무 내용</div>
                  <div style={{background:"#f6f8fa", borderRadius:8, padding:12, fontSize:13, whiteSpace:"pre-wrap"}}>{selected.content}</div>
                </div>

                {selected.reason_process && (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12, color:"#2b7a2b", fontWeight:700, marginBottom:6}}>앞/뒤 프로세스</div>
                    <div style={{background:"#f6f8fa", borderRadius:8, padding:12, fontSize:13}}>{selected.reason_process}</div>
                  </div>
                )}
                {selected.reason_next && (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12, color:"#2b7a2b", fontWeight:700, marginBottom:6}}>뒷사람 입장</div>
                    <div style={{background:"#f6f8fa", borderRadius:8, padding:12, fontSize:13}}>{selected.reason_next}</div>
                  </div>
                )}
                {selected.ref_form && (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12, color:"#2b7a2b", fontWeight:700, marginBottom:6}}>참고 양식</div>
                    <div style={{background:"#f6f8fa", borderRadius:8, padding:12, fontSize:13}}>{selected.ref_form}</div>
                  </div>
                )}
                {selected.ref_material && (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12, color:"#2b7a2b", fontWeight:700, marginBottom:6}}>참고 자료</div>
                    <div style={{background:"#f6f8fa", borderRadius:8, padding:12, fontSize:13}}>{selected.ref_material}</div>
                  </div>
                )}
              </div>

              {/* 오른쪽: 대화 + 상태 버튼 */}
              <div className={styles.modalRight}>
                <div style={{display:"flex", justifyContent:"flex-end", marginBottom:8}}>
                <button onClick={() => setSelected(null)} style={{
                  border:"1px solid #d0d7de", background:"#f6f8fa",
                  borderRadius:6, padding:"3px 10px", fontSize:12,
                  cursor:"pointer", color:"#555", fontWeight:500, width:"60px"
                }}>닫기</button>
              </div>

                <TaskQnA taskId={selected.id} currentUserId={me} />

                {selected.status !== "done" && (
                  <div style={{display:"flex", flexDirection:"row", gap:8, marginTop:12}}>
                    {selected.status === "pending" && (
                      <button style={{
                        flex:1, padding:"10px 0", background:"#fff8e1",
                        color:"#b45309", border:"1px solid #f59e0b",
                        borderRadius:8, fontWeight:700, fontSize:13, cursor:"pointer"
                      }}
                        onClick={() => { handleStatusChange(selected.id, "inprogress"); setSelected(null); }}
                      >진행중</button>
                    )}
                    <button style={{
                      flex:1, padding:"10px 0", background:"#2ecc71",
                      color:"#fff", border:"none",
                      borderRadius:8, fontWeight:700, fontSize:13, cursor:"pointer"
                    }}
                      onClick={() => handleCompleteFlow(selected)}


                    >완료</button>
                  </div>
                )}

              </div>

            </div>
          </div>
        )}  

        {completeChoice && (
          <div style={{
            position:"fixed", inset:0, background:"rgba(0,0,0,0.45)",
            display:"flex", alignItems:"center", justifyContent:"center", zIndex:1100
          }} onClick={() => setCompleteChoice(null)}>
            <div onClick={(e) => e.stopPropagation()} style={{
              background:"#fff", borderRadius:12, padding:24, width:380, maxWidth:"92vw"
            }}>
              <div style={{fontSize:15, fontWeight:700, marginBottom:6}}>완료 처리</div>
              <div style={{fontSize:13, color:"#666", marginBottom:20, lineHeight:1.6}}>
                실제 난이도와 소요시간을 수정하시겠어요?
              </div>
              <div style={{display:"flex", gap:8}}>
                <button type="button" onClick={handleChooseSkip}
                  style={{flex:1, padding:"11px 0", borderRadius:8, border:"1px solid #d0d7de",
                          background:"#fff", color:"#555", fontWeight:600, cursor:"pointer", fontSize:13}}>
                  미수정 · 지시대로 완료
                </button>
                <button type="button" onClick={handleChooseEdit}
                  style={{flex:1, padding:"11px 0", borderRadius:8, border:"none",
                          background:"#2ecc71", color:"#fff", fontWeight:700, cursor:"pointer", fontSize:13}}>
                  수정하고 완료
                </button>
              </div>
            </div>
          </div>
        )}

        {actualModal && (
          <div style={{
            position:"fixed", inset:0, background:"rgba(0,0,0,0.45)",


            display:"flex", alignItems:"center", justifyContent:"center", zIndex:1100
          }} onClick={() => setActualModal(null)}>
            <div onClick={(e) => e.stopPropagation()} style={{
              background:"#fff", borderRadius:12, padding:24, width:360, maxWidth:"92vw"
            }}>
              <div style={{fontSize:15, fontWeight:700, marginBottom:4}}>실제 난이도 · 소요시간</div>
              <div style={{fontSize:12, color:"#888", marginBottom:16}}>
                실제로 해보니 어땠는지 입력하면 완료 처리됩니다.
              </div>

              <div style={{marginBottom:14}}>
                <div style={{fontSize:13, color:"#555", marginBottom:6}}>실제 난이도 (1 ~ 10)</div>
                <div style={{display:"flex", alignItems:"center", gap:8}}>
                  <input type="number" min="1" max="10" value={actualDiff}
                    onChange={(e) => setActualDiff(e.target.value)}
                    style={{width:70, height:36, padding:"0 10px", boxSizing:"border-box",
                            border:"1px solid #d0d7de", borderRadius:6, fontSize:14}} />
                  <span style={{fontSize:13, color:"#666"}}>/ 10 점</span>
                </div>
              </div>

              <div style={{marginBottom:20}}>
                <div style={{fontSize:13, color:"#555", marginBottom:6}}>실제 소요 시간</div>
                <div style={{display:"flex", alignItems:"center", gap:6}}>
                  <select value={actualHours} onChange={(e) => setActualHours(e.target.value)}
                    style={{height:36, padding:"0 8px", boxSizing:"border-box",
                            border:"1px solid #d0d7de", borderRadius:6, fontSize:14}}>
                    {Array.from({length:13}, (_, h) => <option key={h} value={h}>{h}</option>)}
                  </select>
                  <span style={{fontSize:13, color:"#666"}}>시간</span>
                  <select value={actualMins} onChange={(e) => setActualMins(e.target.value)}
                    style={{height:36, padding:"0 8px", boxSizing:"border-box",
                            border:"1px solid #d0d7de", borderRadius:6, fontSize:14}}>
                    {[0,5,10,15,20,25,30,35,40,45,50,55].map((m) => <option key={m} value={m}>{m}</option>)}



                  </select>
                  <span style={{fontSize:13, color:"#666"}}>분</span>
                </div>
              </div>

              <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
                <button type="button" onClick={() => setActualModal(null)}
                  style={{padding:"8px 16px", borderRadius:8, border:"1px solid #d0d7de",
                          background:"#fff", color:"#555", cursor:"pointer", fontSize:13}}>취소</button>
                <button type="button" onClick={handleActualSave}
                  style={{padding:"8px 20px", borderRadius:8, border:"none",
                          background:"#2ecc71", color:"#fff", fontWeight:700, cursor:"pointer", fontSize:13}}>저장하고 완료</button>
              </div>
            </div>
          </div>
        )}


      </div>

    </div>
  );
}